export function base64Encode(str: string) {
	return encodeURIComponent(window.btoa(str));
}
